import {Component, OnInit, Input, Optional, Self} from '@angular/core';
import {FormGroup, NgControl} from '@angular/forms';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import {ComparableOperator} from "../../../../models/form";

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss']
})
export class TextInputComponent extends BaseAnswerTypeComponent<string> implements OnInit {
  @Input() maxLength: number = 4000;
  @Input() minLength: number = 3;
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() inputType: 'text' | 'email' | 'number' = 'text';
  @Input() dynamicFilter: boolean = false;
  @Input() readonly: boolean;
  @Input() preventKeys: string[] = [];
  @Input() allowTextArea: boolean = false;

  minimunCharValidation: boolean = false;

  constructor(@Optional() @Self() ngControl?: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    
    this.ngControl?.valueChanges
    .subscribe(
      changes => {
        if(this.dynamicFilter){
          if(changes?.split('')?.length < 3 && changes?.split('')?.length !== 0 && changes !== ''){
            this.minimunCharValidation = true;
          }else{
            this.minimunCharValidation = false;
          }
        }
      }
    )
  }

  keyDown($event): void {
    if (this.dynamicFilter) {
      this.preventKey($event);
    }
  }

  preventKey(event): void {
    if (this.preventKeys?.length && this.preventKeys.some(key => key == event.key)) {
        event.preventDefault();
    }
  }

  AllowedOperators: {[K in ComparableOperator]: (t: string, value: string) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (target: string) => !target,
    [ComparableOperator.NotIsNullOrEmpty]: (target: string, value) => !!target,
    [ComparableOperator.Between]: null,
    [ComparableOperator.Empty]: null,
    [ComparableOperator.Completed]: null,
  }

}
